class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(".carousel-track");
    this.querySelectorAll("[data-step]").forEach((button) => {
      button.addEventListener("click", () => this.step(Number(button.dataset.step)));
    });
  }

  show(index) {
    this.track.scrollTo({ left: index * this.track.clientWidth, behavior: "smooth" });
  }

  // Moves one image per click and wraps around at either end.
  step(direction) {
    const { scrollLeft, clientWidth, scrollWidth } = this.track;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
    let left = scrollLeft + direction * clientWidth;

    if (direction > 0 && atEnd) left = 0;
    if (direction < 0 && atStart) left = scrollWidth;

    this.track.scrollTo({ left, behavior: "smooth" });
  }
}

customElements.define("product-carousel", ProductCarousel);

// One dropdown per product option (e.g. Color, Size). Keeps the form's
// variant id in sync and shows the variant's image in the carousel.
class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector("script[type='application/json']").textContent);
    this.selects = [...this.querySelectorAll("select")];
    this.selects.forEach((select, index) => {
      for (const option of select.options) {
        option.disabled = !this.variants.some(
          (variant) => variant.available && variant.options[index] === option.value,
        );
      }
      select.addEventListener("change", () => this.update());
    });
  }

  update() {
    const values = this.selects.map((select) => select.value);
    const variant = this.variants.find((candidate) =>
      candidate.options.every((value, index) => value === values[index]),
    );
    const form = this.closest("form");
    const button = form.querySelector("[type=submit]");

    form.querySelector("input[name=id]").value = variant?.id ?? "";
    button.disabled = !variant?.available;
    button.textContent = variant?.available ? "Add to Cart" : "Sold Out";
    if (variant) {
      this.closest(".product").querySelector("[data-price]").textContent = formatMoney(variant.price);
    }

    if (variant?.featured_image) {
      this.closest(".product")
        .querySelector("product-carousel")
        .show(variant.featured_image.position - 1);
    }
  }
}

customElements.define("variant-picker", VariantPicker);

// Variant prices from product JSON are in cents.
function formatMoney(cents) {
  return new Intl.NumberFormat(document.documentElement.lang, {
    style: "currency",
    currency: window.Shopify?.currency?.active ?? "USD",
  }).format(cents / 100);
}

// Adds products to the cart without leaving the page and refreshes the
// header count. Without JS the form posts to /cart as usual.
document.addEventListener("submit", async (event) => {
  const form = event.target;
  if (!form.matches("form[action$='/cart/add']")) return;

  event.preventDefault();
  const button = form.querySelector("[type=submit]");
  const label = button.textContent;
  button.disabled = true;

  try {
    const response = await fetch(`${form.action}.js`, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form),
    });

    if (!response.ok) {
      const { description } = await response.json();
      window.alert(description);
      return;
    }

    await updateCartCount();
    button.textContent = "Added";
    await new Promise((resolve) => setTimeout(resolve, 1500));
  } finally {
    button.textContent = label;
    button.disabled = false;
  }
});

async function updateCartCount() {
  const link = document.querySelector("[data-cart-link]");
  const response = await fetch(`${link.href}.js`);
  const { item_count } = await response.json();
  link.querySelector("[data-cart-count]").textContent = item_count;
}

// Background videos autoplay muted; respect reduced motion.
if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  document.querySelectorAll("video[autoplay]").forEach((video) => {
    video.removeAttribute("autoplay");
    video.pause();
  });
}
